export default {
    state: {
        refrescando: -1,
    },
    mutations: {
        setTrue(state) {
            state.refrescando++;
        },
        setFalse(state) {
            state.refrescando = -1;
        },
    },
    getters: {
        getEstado: state => {
            return state.refrescando > 0 && !state.refrescando < 90;
        },
    }
}
